import SortAlphabeticalIcon from './component'

export default SortAlphabeticalIcon
